import React from 'react'
import styled from 'styled-components'
import { ReactComponent as Arrow } from "../../Assets/iconsv2/generic/forwardArrow.svg"

const SettingsElementWithArrow = ({ text, onClick }) => {
    return (
        <SettingsElementContainer
            onClick={onClick}
        >
            <ElementText>{text}</ElementText>  <Arrow />
        </SettingsElementContainer>
    )
}

export default SettingsElementWithArrow
const SettingsElementContainer = styled.div`
display:flex;
width:100%;
align-items:center;
justify-content:space-between;
gap:12px;
cursor:pointer;
 color:${({ theme, customColor }) => (customColor ? customColor : theme.menu.secondaryTextColor)};
padding:16px 0;
svg{
max-height:20px;
max-width:20px;
}

${(props) => props.reverse &&
        `
  flex-direction:row-reverse;
justify-content:space-between;
  `}

`

const ElementText = styled.p`
font-family: Inter;
font-weight: 500;
font-size: 16px;
line-height: 22px;
letter-spacing: -0.41px;
 color:${({ theme, customColor }) => (customColor ? customColor : theme.menu.secondaryTextColor)};
`